import { type Chart, type ScriptableScaleContext } from 'chart.js';
import { getLineGradient } from './getLineGradient';

type ChartContext = {
  chart: Chart;
};

/**
 * Create Gradient border for line graph border
 */
export const getGradientBorderColor = (context: ChartContext) => {
  const { chart } = context;
  const { ctx, chartArea } = chart;

  if (!chartArea) {
    // This case happens on initial chart load
    return;
  }
  return getLineGradient(ctx, chartArea);
};

/**
 * Styles for X-Axis Ticks
 */
export const xAxisTickConfig = {
  stepSize: 0.5,
  color: ({ tick }: ScriptableScaleContext) => {
    const value = tick.value;
    return value % 1 === 0 ? '#2563FF' : '#6C7589';
  },
  font: ({ tick }: ScriptableScaleContext) => {
    const value = tick?.value;
    const weight = value % 1 === 0 ? 700 : 400;

    return {
      weight,
      size: 16,
    };
  },
};
